//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Utils imports
import { QUERY_KEYS } from "@/utils/query-client";

//* Types imports
import type { PhaseFormOutputDTO } from "@/features/phaseForm/types";

async function indexPhaseFormsByProduct(
  productId: string,
): Promise<PhaseFormOutputDTO[]> {
  const response = await fetch(`${API_URL}/phaseforms/product/${productId}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch phase forms by product");
  }

  return response.json();
}

export function useIndexPhaseFormsByProduct(productId?: string | null) {
  return useQuery<PhaseFormOutputDTO[]>({
    queryKey: [QUERY_KEYS.PHASE_FORMS.BY_PRODUCT, productId],
    queryFn: () => indexPhaseFormsByProduct(productId!),
    enabled: !!productId,
  });
}
